import { render } from "./custom-spinner.vue?vue&type=template&id=083a9c30&scoped=true&ts=true"
import script from "./custom-spinner.ts?vue&type=script&lang=ts&external"
export * from "./custom-spinner.ts?vue&type=script&lang=ts&external"

import "./custom-spinner.scss?vue&type=style&index=0&id=083a9c30&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083a9c30"]])

export default __exports__